import {constants} from '../../constants';
import {TrackReadyToBoardInterface} from '../interfaces';

import {TrackingUtilsService} from './tracking-utils.service';
import {AnalyticsService} from '../../modules/core/services/analytics.services';
import {retrieveAnalyticsServiceValuesCase} from './retrieve-analytics-service-values.case';

export const trackReadyToBoardPayloadCase = (
  analyticsService: AnalyticsService,
  trackingUtilsService: TrackingUtilsService,
  guestData?: any,
): TrackReadyToBoardInterface | undefined => {
  if (!guestData) return undefined;

  const {analyticsData, language, brand, loyaltyNum, vdsId, platform} = retrieveAnalyticsServiceValuesCase(analyticsService, trackingUtilsService, guestData?.loggedInPaxId);
  return {
    pageName: constants.PAGE_NAME_FOR_TRACKING.READY_TO_BOARD,
    brand: brand ?? '',
    country: analyticsData?.country,
    language: language ? language.toLowerCase() : 'en',
    siteSection: analyticsData?.channel,
    consumerId: analyticsData?.paxid,
    loyaltyNum: loyaltyNum ?? '',
    passengerId: guestData.loggedInPaxId ?? constants.DEFAULT_GUEST_ID_FOR_TRACKING.ID,
    vdsId,
    bookingId: guestData.bookingId,
    platform: platform ?? '',
    loginStatus: constants.LOGIN_STATUS.LOGGED_IN
  };
}
